import { LitElement, html, type PropertyValues } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import confetti from 'canvas-confetti';

/**
 * Larger celebration triggered when the user reaches a streak threshold
 * (default 3 consecutive correct answers in a session). Wraps `canvas-confetti`.
 */
@customElement('streak-celebration')
export class StreakCelebration extends LitElement {
  @property({ type: Boolean }) show = false;

  override updated(changed: PropertyValues<this>): void {
    if (changed.has('show') && this.show) {
      this.fireConfetti();
      window.setTimeout(() => {
        this.show = false;
        this.dispatchEvent(new CustomEvent('streak-done', { bubbles: true, composed: true }));
      }, 1200);
    }
  }

  private fireConfetti(): void {
    const colors = ['#FFD23F', '#FF5D8F', '#3EC1D3', '#B6E388'];
    confetti({
      particleCount: 80,
      spread: 70,
      startVelocity: 35,
      origin: { y: 0.6 },
      colors,
    });
    confetti({
      particleCount: 60,
      spread: 100,
      startVelocity: 25,
      origin: { y: 0.8 },
      colors,
    });
  }

  override render() {
    return html``;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'streak-celebration': StreakCelebration;
  }
}
